<!-- Header -->
<div class="promo_band text-center">
    <div class="center-align">sign up for your 14-day FREE Trial today!</div>
    <div class="right-align">*No Credit Card Required</div>
</div>
<header id="header" class="fc_header gray_bg sticky-top" [ngClass]="{'is-sticky': isScrolled}">
    <nav class="navbar navbar-expand-md  bg-dark navbar-light">
        <div class="container-fluid flex-md-wrap flex-lg-nowrap justify-content-md-center">
            <a class="navbar-brand" href="/">
                <img class="fc_logo" src="/assets/images/familycentral-logo.svg" width="140" height="70"
                    alt="Family central logo">
            </a>
            <button class="navbar-toggler info_btn m-0" type="button" data-bs-toggle="collapse"
                data-bs-target="#fcNavbar" aria-label="Mobile menu">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse gap-3" id="fcNavbar">
                <ul class="navbar-nav me-auto">
                    <li class="nav-item">
                        <a class="nav-link" [ngClass]="{'active': isAboutUspage}" href="/aboutus">About Us</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [ngClass]="{'active': isHowitworkspage}" href="/how-it-works">How It
                            Works</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/price-details" [routerLinkActive]="['active']">Pricing</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="/families" [ngClass]="{'active': isFamiliespage}">For Families</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/professional" [routerLinkActive]="['active']">For
                            Advisors</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/contactus" [routerLinkActive]="['active']">Contact Us</a>
                    </li>
                </ul>
                <div class="header_right">
                    <ul class="nav">
                        <li class="nav-item">
                            <a class="nav-link" routerLink="/login" [routerLinkActive]="['active']">Log In</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link primary_btn" routerLink="/signup-type">Get started</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
</header>